import { UploadOutlined } from '@ant-design/icons'
import { Upload, Flex } from 'antd'
import { RcFile } from 'antd/es/upload'
import { useEffect, useState } from 'react'

type Props = {
  imageFile: RcFile | undefined
  setImageFile: (value: RcFile) => void
  imageBase64: string | undefined
  setImageBase64: (value: string) => void
  isDisabled?: boolean
}

const UploadOneImage = (props: Props) => {
  const { setImageFile, imageBase64, setImageBase64, isDisabled } = props
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [heightUpload, setHeightUpload] = useState<number>(150)
  const [widthUpload, setWidthUpload] = useState<number>(200)

  const uploadButton = (
    <Flex vertical justify='center' align='center'>
      <UploadOutlined className='text-[30px] text-[#6B7280]' />
      <p className='flex mt-2 text-center text-[#6B7280] whitespace-pre-line'>
        {`ここに画像を1枚だけでドロップ\n-または-\nクリックしてアップロード`}
      </p>
    </Flex>
  )

  const onChange = (info: any) => {
    const croppedImage = info.file.originFileObj
    setImageFile(croppedImage)

    const reader: any = new FileReader()
    reader.readAsDataURL(croppedImage)

    reader.onload = () => setImageBase64(reader.result)
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setHeightUpload((150 * windowWidth) / 750)
    setWidthUpload((200 * windowWidth) / 750)
  }, [windowWidth])

  return (
    <Upload
      listType='picture'
      onChange={onChange}
      name='avatar'
      className='avatar-uploader'
      showUploadList={false}
      disabled={isDisabled}
    >
      <Flex
        className='cursor-pointer p-3 mt-2'
        justify='center'
        align='center'
        style={{
          height: heightUpload,
          width: widthUpload,
          maxHeight: 440,
          maxWidth: 570,
          borderStyle: 'dashed',
          borderWidth: 0.5,
          borderRadius: 10,
          borderColor: '#6B7280'
        }}
      >
        {imageBase64 ? (
          <img
            src={imageBase64}
            alt='avatar'
            style={{ width: 'auto', height: heightUpload * 0.9, maxHeight: '95%', maxWidth: '95%' }}
          />
        ) : (
          uploadButton
        )}
      </Flex>
    </Upload>
  )
}

export default UploadOneImage
